import { LuneThemeNew, Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'
import { FC } from 'react'

const { palette } = LuneThemeNew

const MiniChip: FC<{ label: string; noTextWrap?: boolean }> = ({ label, noTextWrap }) => {
    return (
        <Box
            sx={{
                backgroundColor: palette.Surface300,
                borderRadius: '100px',
                padding: '4px 6px',
                width: 'max-content',
                maxWidth: noTextWrap ? 'max-content' : '120px',
                overflow: 'hidden',
                flex: noTextWrap ? '1 0 max-content' : '0 1 auto',
            }}
        >
            <Text
                variant={'caption'}
                sx={{
                    color: palette.TextTertiary,
                    display: 'block',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%',
                    overflow: 'hidden',
                    width: 'max-content',
                }}
            >
                {label}
            </Text>
        </Box>
    )
}

export default MiniChip
